import { Rutas } from '@/constants/rutas';
import FantasyMarcaIcon from '@/components/shared/icons/FantasyMarcaIcon';

export const NavigationFantasyMarcaItems = [
    {
        title: 'Mercado Marca',
        shortTitle: 'Mercado Marca',
        path: Rutas.FANTASY_MARCA_MERCADO,
        id: 'mercado-fantasy-marca',
        icon: <FantasyMarcaIcon width={20} height={20} />,
    },
    // {
    //     title: 'Puja Ideal Biwenger',
    //     shortTitle: 'Puja',
    //     path: Rutas.PUJA_FANTASY_BIWENGER,
    // },
    // {
    //     title: 'Estadísticas Biwenger',
    //     shortTitle: 'Estadísticas',
    //     path: Rutas.ESTADISTICAS_BIWENGER,
    // },
    {
        title: 'Chollos Fantasy Marca',
        shortTitle: 'Chollos',
        path: Rutas.CHOLLOS_FANTASY_MARCA,
    },
    {
        title: 'Puntuaciones Fantasy Marca',
        shortTitle: 'Puntuaciones',
        path: Rutas.PUNTUACIONES_FANTASY_MARCA,
    },
    {
        id: 'fantasy-marca-estadisticas',
        title: 'Estadísticas Fantasy Marca',
        shortTitle: 'Stats',
        icon: <FantasyMarcaIcon width={20} height={20} />,
        path: Rutas.ESTADISTICAS_FANTASY_MARCA_ANALYTICS,
    },
];
